import React from 'react';

const CareersSkeleton = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <div
          key={item}
          className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition-all duration-300 animate-pulse"
        >
          {/* Career Content Skeleton */}
          <div className="p-6">
            {/* Company Name Skeleton */}
            <div className="h-6 bg-gray-200 rounded mb-3 w-3/4"></div>

            {/* Position Title Skeleton */}
            <div className="h-5 bg-gray-200 rounded mb-4 w-4/5"></div>

            {/* Action Buttons Skeleton */}
            <div className="flex gap-2">
              {/* View Button Skeleton */}
              <div className="flex items-center justify-center gap-2 bg-gray-200 text-gray-200 py-2 px-4 rounded-lg font-semibold w-20">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-8"></div>
              </div>

              {/* Edit Button Skeleton */}
              <div className="flex items-center justify-center gap-2 bg-gray-200 text-gray-200 py-2 px-4 rounded-lg font-semibold w-20">
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
                <div className="h-4 bg-gray-300 rounded w-8"></div>
              </div>

              {/* Delete Button Skeleton */}
              <div className="flex items-center justify-center gap-2 bg-gray-200 text-gray-200 py-2 px-4 rounded-lg font-semibold w-24">
                <div className="h-4 bg-gray-300 rounded w-12"></div>
                <div className="w-4 h-4 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CareersSkeleton;